var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_vm.displayedNewsItems && _vm.displayedNewsItems.length ? _vm._l(_vm.displayedNewsItems, function (item) {
    return _c('NewsCard', {
      key: item.id,
      attrs: {
        "newsItem": item
      }
    });
  }) : [_c('div', {
    staticClass: "coming-soon-container"
  }, [_vm.errorImageMobile ? _c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.errorImageDesktop,
      "media": "(min-width: 768px)"
    }
  }), _c('img', {
    attrs: {
      "src": _vm.errorImageMobile,
      "alt": "News Coming Soon"
    }
  })]) : _vm._e(), _c('p', [_vm._v("News Articles Coming Soon")])])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }